export const hostName = Tickets.appPath;

export const endpoints = {
  event: {
    getMedia: "/_api/events/media",
    getEvents: "/_api/playdetails/getevents",
    getvalue: "/_api/playdetails/getvalue",
    getProducers: "/_api/playdetails/getProducers",
    getArtist: (artistId, culture) =>
      `/_api/artists/${artistId}?culture=${culture}`,
    getArtistMedia: (artistId, culture) =>
      `/_api/artists/${artistId}/media?culture=${culture}`,
    getArtistEventGroups: (artistId, culture) =>
      `/_api/artists/${artistId}/eventgroups?culture=${culture}`,
    getEventGroupArtists: (eventGroupId, culture) =>
      `/_api/artists/eventgroup/${eventGroupId}/?culture=${culture}`,
    followArtist: (artistId) => `/_api/artists/${artistId}/follow`,
  },
};

export const eventPropKeys = [
  "duration",
  "intermission",
  "allowCancel",
  "allowUpdate",
  "hasParking",
  "hasSeats",
  "accessInfo",
  "venueId",
  "accessibility",
];

export const colors = {
  grey: "#F7F7F7",
};

export const ACCESSIBILITY_OPTIONS = {
  WHEELCHAIR: {
    bit: 1,
    text: playdetailsv2_resources.WheelchairAvailableResource,
  },
  RESTROOM: {
    bit: 2,
    text: playdetailsv2_resources.RestroomResource,
  },
  RAMPS: {
    bit: 4,
    text: playdetailsv2_resources.RampsResource,
  },
  EMERGENCY_EXITS: {
    bit: 8,
    text: playdetailsv2_resources.EmergencyExitsResource,
  },
  ELEVATOR: {
    bit: 16,
    text: playdetailsv2_resources.ElevatorResource,
  },
  PARKING: {
    bit: 32,
    text: playdetailsv2_resources.PRMParkingResource,
  },
  HEARING_AID: {
    bit: 64,
    text: playdetailsv2_resources.HearingAidResource,
  },
  VISUAL_AID: {
    bit: 128,
    text: playdetailsv2_resources.VisualAidsResource,
  },
  COMPANION: {
    bit: 256,
    text: playdetailsv2_resources.CompanionResource,
  },
  SERVICE_DOGS: {
    bit: 512,
    text: playdetailsv2_resources.ServiceDogsResource,
  },
  SUBTITLES: {
    bit: 1024,
    text: playdetailsv2_resources.SubtitlesResource,
  },
};
